import * as constants from 'actions/constants';
import { EntryType } from 'actions/general';
import { removeEntriesFromArrayById, removeEntryFromArrayById } from 'helpers/array';
import { Event } from 'types/event';
import { EntryDateIndex } from './postReducer';
import { entryListToMap, entryListToIndexes, entryMapToEntryIndex } from 'helpers/general';

const defaultState: EventReducer = {
  events: new Map(),
  entryDateIndex: [],
  loading: false,
};

export interface EventReducer {
  events: Map<string, Event>;
  entryDateIndex: EntryDateIndex[];
  loading: boolean;
}

const eventReducer: (state: EventReducer, action: any) => EventReducer = (
  state: EventReducer = defaultState,
  action: any
) => {
  switch (action.type) {
    case constants.GET_LATEST_EVENTS_TRY:
      return { ...state, loading: true };

    case constants.GET_LATEST_EVENTS_ERROR:
      return { ...state, loading: false };

    case constants.GET_LATEST_EVENTS_RESPONSE: {
      if (action.response.success) {
        const eventsObject = new Map(state.events);
        const newEvents = entryListToMap<Event>(action.response.entries, eventsObject);
        return {
          ...state,
          events: newEvents,
          entryDateIndex: entryMapToEntryIndex<Event>(newEvents),
          loading: false,
        };
      }
      return { ...state, loading: false };
    }


    case constants.GET_MY_EVENTS_RESPONSE: {
      if (action.response.success) {
        const newDateIndex = entryListToIndexes(
          action.response.myEntries,
          [...state.entryDateIndex]
        );
        const updatedEvents = new Map(state.events);
        action.response.myEntries
        return {
          ...state,
          events: updatedEvents,
          entryDateIndex: newDateIndex,
        };
      }
      return state;
    }

    case constants.DELETE_EVENT_RESPONSE: {
      if (!action.response.success) return state;

      const updatedEntryDateIndex = removeEntryFromArrayById(state.entryDateIndex, action.entryId);
      const updatedEvents = new Map(state.events);
      updatedEvents.delete(action.entryId);
      return {
        ...state,
        events: updatedEvents,
        entryDateIndex: updatedEntryDateIndex,
      };
    }

    case constants.GET_EVENT_RESPONSE: {
      if (action.response.success) {
        const updatedEvents = new Map(state.events);
        const newEventMap = entryListToMap<Event>([action.response.entry], updatedEvents);
        return {
          ...state,
          events: newEventMap,
          entryDateIndex: entryListToIndexes<Event>([action.response.entry], [...state.entryDateIndex]),
        };
      }
      if (action.response.status === 404) {
        if (!state.events.has(action.entryId)) return state;

        const updatedEvents = new Map(state.events);
        updatedEvents.delete(action.entryId);
        const updatedEntryDateIndex = removeEntryFromArrayById(state.entryDateIndex, action.entryId);
        return {
          ...state,
          events: updatedEvents,
          entryDateIndex: updatedEntryDateIndex,
        };
      }
      return state;
    }

    case constants.ATTEND_EVENT_RESPONSE:
    case constants.SEND_RATING_TO_EVENT_RESPONSE:
    case constants.CREATE_EVENT_RESPONSE: {
      if (action.response.success) {
        const updatedEvents = new Map(state.events);
        const newEventMap = entryListToMap<Event>([action.response.entry], updatedEvents);
        return {
          ...state,
          events: newEventMap,
          entryDateIndex: entryListToIndexes<Event>([action.response.entry], [...state.entryDateIndex]),
        };
      }
      return state;
    }

    case constants.CLEAR_OLD_DATA: {
      if (action.force && action.entryType === EntryType.EVENT) return defaultState;
      if (state.entryDateIndex.length < 30) return state;

      const newEntryDateIndex = state.entryDateIndex.sort((a, b) => b.date - a.date).slice(0, 30);
      const updatedEvents = new Map(state.events);

      state.entryDateIndex.forEach(entryIndex => {
        if (!newEntryDateIndex.includes(entryIndex)) {
          updatedEvents.delete(entryIndex.entryId);
        }
      });
      return {
        ...state,
        events: updatedEvents,
        entryDateIndex: newEntryDateIndex,
      };
    }

    case constants.LOGOUT_RESPONSE:
      return defaultState;

    default:
      if (action?.response?.code === 'FORCE_LOGOUT_FRONTEND') return defaultState;
      return state;
  }
};

export default eventReducer;
